
const RemovalsServices = () => {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Local Home Removals',
      description: 'Moving within Durban or Pinetown? Our bakkie with trailer is perfect for flats, apartments, and small homes. We handle furniture, appliances, and boxes with care.',
      features: ['Same-day service available', 'Careful furniture handling', 'Affordable flat rates', 'No hidden fees'],
    },
    {
      icon: 'ri-building-line',
      title: 'Office Furniture Transport',
      description: 'Relocating your office? We transport desks, chairs, filing cabinets, computers, and office equipment safely across KZN with minimal disruption to your business.',
      features: ['Weekend moves available', 'Professional packing', 'Equipment protection', 'Flexible scheduling'],
    },
    {
      icon: 'ri-road-map-line',
      title: 'Long-Distance Removals',
      description: 'Moving across KwaZulu-Natal? We provide reliable long-distance bakkie removals from Durban to Pietermaritzburg, rural areas, and everywhere in between.',
      features: ['All KZN coverage', 'Insured transport', 'Competitive pricing', 'Urban &amp; rural service'],
    },
    {
      icon: 'ri-sofa-line',
      title: 'Furniture Transport',
      description: 'Bought new furniture or selling items? We transport couches, beds, wardrobes, dining sets, and all types of furniture safely with protective materials.',
      features: ['Protective wrapping', 'Secure loading', 'Damage prevention', 'Single item transport'],
    },
    {
      icon: 'ri-fridge-line',
      title: 'Appliance Transport',
      description: 'Moving fridges, washing machines, stoves, or other appliances? Our team handles heavy appliances with specialized equipment and techniques.',
      features: ['Heavy lifting expertise', 'Appliance protection', 'Safe transportation', 'Installation assistance'],
    },
    {
      icon: 'ri-plant-line',
      title: 'Garden Waste Removal',
      description: 'Need to remove garden waste, old furniture, or unwanted items? We provide efficient waste removal and disposal services across Durban and KZN.',
      features: ['Garden waste removal', 'Furniture disposal', 'Responsible disposal', 'Quick service'],
    },
  ];

  return (
    <div className="mb-16">
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Our Bakkie Removal Services
      </h2>
      <p className="text-gray-600 text-lg mb-12 leading-relaxed">
        Look Who's Moving specializes in small bakkie removals with trailers, offering comprehensive transport solutions for residential and commercial clients across KwaZulu-Natal. All our vehicles are fully insured, and we pride ourselves on transparent pricing with no hidden fees.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {services.map((service, index) => (
          <div key={index} className="bg-greenbg rounded-xl p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${service.icon} text-white text-2xl w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-xl text-charcoal mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-checkbox-circle-fill text-primary mr-2 w-4 h-4 flex items-center justify-center"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-primary/10 border-l-4 border-primary rounded-lg p-6">
        <h4 className="font-bold text-xl text-charcoal mb-3 flex items-center">
          <i className="ri-price-tag-3-line text-primary mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
          Transparent Pricing Guarantee
        </h4>
        <p className="text-gray-700 leading-relaxed">
          At Look Who's Moving, we believe in honest, upfront pricing. You'll receive a clear quote before we start, with no surprise charges or hidden fees. Our rates are competitive and based on distance, volume, and specific requirements. Contact us for a free, no-obligation quote via WhatsApp at <strong>079 876 8956</strong> or email <strong>bookings@lookwhosmoving.co.za</strong>.
        </p>
      </div>
    </div>
  );
};

export default RemovalsServices;
